import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ActionList } from '../../common/actions';
import ActionEnableForm from './ActionEnableForm';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { APP_WRITE, DIRECTUS, SUPABASE, XANO } from 'drapcode-constant';

class ActionEnableModal extends Component {
  actionData = (action) => {
    return ActionList.find((param) => {
      return param.name === action.name;
    });
  };
  actionEnableForm = (eventAction, actionData) => {
    const {
      actions,
      hideModal,
      selectedEvent,
      showLoaderForAction,
      projectId,
      events,
      version,
      showLoaderForEnableAction,
    } = this.props;

    return (
      <ActionEnableForm
        hideModal={hideModal}
        actions={actions}
        version={version}
        eventAction={eventAction}
        actionData={actionData}
        selectedEvent={selectedEvent}
        projectId={projectId}
        showLoaderForAction={showLoaderForAction}
        events={events}
        showLoaderForEnableAction={showLoaderForEnableAction}
      />
    );
  };

  displayActionLabel = (label) => {
    return label ? (label === 'Dynamic Page Redirect' ? 'Conditional Redirect' : label) : '';
  };

  showIcon = (action) => {
    switch (action.name) {
      case 'triggerZap':
        return (
          <img
            src={require('../../common/dataSource/img/zapier.svg')}
            alt={action.label}
            className="mr-3 svg"
          />
        );
      case 'sendDataToExternalApi':
      case 'sendDataToExternalApiAndAuthorize':
      case 'sendDataToExternalApiAndFileDownload':
      case 'sendDataToExternalSource':
      case 'sendDataToExternalSourceAndFileDownload':
      case 'authorizeWithExternalDataSource':
        if (action.source && action.source === SUPABASE) {
          return (
            <img
              src={require('../../common/dataSource/img/supabase.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === DIRECTUS) {
          return (
            <img
              src={require('../../common/dataSource/img/directus.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === APP_WRITE) {
          return (
            <img
              src={require('../../common/dataSource/img/appwrite.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else if (action.source && action.source === XANO) {
          return (
            <img
              src={require('../../common/dataSource/img/xano.svg')}
              alt={`${action.label}`}
              className="mr-3 svg"
            />
          );
        } else {
          return <i className={`mr-3 wb ${drapcodeIcon(action.name)}`} />;
        }
      default:
        return <i className={`mr-3 wb ${drapcodeIcon(action.name)}`} />;
    }
  };

  render() {
    const { show, hideModal } = this.props;
    const { eventAction } = this.props;
    const actionData = this.actionData(eventAction);
    if (actionData) {
      return (
        <Modal isOpen={show} toggle={hideModal} backdrop="static" style={{ marginTop: '100px' }}>
          <ModalHeader toggle={hideModal} className="border-bottom">
            {this.showIcon(eventAction)}
            <strong>{this.displayActionLabel(eventAction.label)}</strong>
          </ModalHeader>
          <ModalBody>{this.actionEnableForm(eventAction, actionData)}</ModalBody>
        </Modal>
      );
    } else {
      return null;
    }
  }
}

export default ActionEnableModal;
